function refine(v, ...args) {
  return typeof v === 'function' ? v(...args) : v;
}

export default refine;
